// assets/quick-order-sticky.js
document.addEventListener('DOMContentLoaded', function () {
  const bar = document.getElementById('quickOrderBar');
  if (!bar) return;

  // Detect if there's a fixed header and adjust position
  const header = document.querySelector('.header-wrapper--fixed');
  const offset = header ? header.offsetHeight : 0;

  bar.style.top = offset + 'px';
});